import { ActionContext } from 'vuex';

import { TBaseFilterPayload } from '@/common/types/filter';
import { getLocalState } from '@/common/utils/store';

import { TAnalyticsNotesFilter } from '../../types/analytics-notes';
import { ANALYTICS_NOTES_YEARLY_ACTIONS_NAME, ANALYTICS_NOTES_YEARLY_MUTATIONS_NAME } from './name';
import { TAnalyticsNotesYearlyState } from './types';

import { TPaginationParams } from '@/types/meta';
import links from '@/utils/links';
import request from '@/utils/request';

export async function searchForeignTradeTable(
  context: ActionContext<TAnalyticsNotesYearlyState, unknown>,
  payload: TBaseFilterPayload<TAnalyticsNotesFilter>,
) {
  return request(
    context,
    {
      url: links.ved.analyticsNotes.yearly.getForeignTradeTable,
      name: getLocalState(ANALYTICS_NOTES_YEARLY_ACTIONS_NAME.searchForeignTradeTable),
      abortController: payload.abortController,
      method: 'post',
    },
    payload.params,
  );
}

export async function searchForeignTradeTemplateData(
  context: ActionContext<TAnalyticsNotesYearlyState, unknown>,
  params: TAnalyticsNotesFilter,
) {
  return await request(
    context,
    {
      url: links.ved.analyticsNotes.yearly.getForeignTrade,
      name: getLocalState(ANALYTICS_NOTES_YEARLY_ACTIONS_NAME.searchForeignTradeTemplateData),
      mutate: getLocalState(ANALYTICS_NOTES_YEARLY_MUTATIONS_NAME.setForeignTradeTemplateData),
      method: 'post',
    },
    params,
  );
}

export async function searchExportStructureTable(
  context: ActionContext<TAnalyticsNotesYearlyState, unknown>,
  payload: TBaseFilterPayload<TAnalyticsNotesFilter>,
) {
  return request(
    context,
    {
      url: links.ved.analyticsNotes.yearly.getExportStructure,
      name: getLocalState(ANALYTICS_NOTES_YEARLY_ACTIONS_NAME.searchExportStructureTable),
      abortController: payload.abortController,
      method: 'post',
    },
    payload.params,
  );
}

export async function searchImportStructureTable(
  context: ActionContext<TAnalyticsNotesYearlyState, unknown>,
  payload: TBaseFilterPayload<TAnalyticsNotesFilter>,
) {
  return request(
    context,
    {
      url: links.ved.analyticsNotes.yearly.getImportStructure,
      name: getLocalState(ANALYTICS_NOTES_YEARLY_ACTIONS_NAME.searchImportStructureTable),
      abortController: payload.abortController,
      method: 'post',
    },
    payload.params,
  );
}

export async function searchExportProductsTable(
  context: ActionContext<TAnalyticsNotesYearlyState, unknown>,
  payload: TBaseFilterPayload<TAnalyticsNotesFilter & TPaginationParams>,
) {
  return request(
    context,
    {
      url: links.ved.analyticsNotes.yearly.getExportMainGoods,
      name: getLocalState(ANALYTICS_NOTES_YEARLY_ACTIONS_NAME.searchExportProductsTable),
      abortController: payload.abortController,
      method: 'post',
    },
    payload.params,
  );
}

export async function searchImportProductsTable(
  context: ActionContext<TAnalyticsNotesYearlyState, unknown>,
  payload: TBaseFilterPayload<TAnalyticsNotesFilter & TPaginationParams>,
) {
  return request(
    context,
    {
      url: links.ved.analyticsNotes.yearly.getImportMainGoods,
      name: getLocalState(ANALYTICS_NOTES_YEARLY_ACTIONS_NAME.searchImportProductsTable),
      abortController: payload.abortController,
      method: 'post',
    },
    payload.params,
  );
}
